import { useColumns } from '~/modules/common/components/ListTable';
import { getFormatters } from '../formatters';
import { buildColumns } from '../columns';

export const useListColumns = props =>
  useColumns({
    columns: buildColumns(props),
    renders: getFormatters(props)
  });
